import { PayItemsOptions } from 'components/CIMSTable/CIMSTableContext/types/actions/header'
import { useEJLogContext } from '../../../EJLogContext'
import { EngineeringJudgement } from '../../../EJLogContext/types'

export function usePayItems(): PayItemsOptions<EngineeringJudgement> {
  const { payItemGlobalId } = useEJLogContext()
  return {
    hidden: !!payItemGlobalId,
    globalId: payItemGlobalId,
    onFilter: (value, { ejToPayItemNoGeometries }) =>
      ejToPayItemNoGeometries.some(
        ({ payItem: { globalId } }) => value === globalId
      ),
  }
}
